import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { useLgStyles } from "./styles";

export function LoginPage() {
  const classes = useLgStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <Box className={classes.main}>
        <Grid container rowSpacing={1}>
          <Grid item md={4} className={classes.leftMain}>
            <Box className={classes.left} flexDirection={"column"}>
              <Box className={classes.loginTexts}>
                <Typography className={classes.MedicalCareText}>
                  {" "}
                  {t("AUTH.LOG_IN_MESSAGE")}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            md={8}
            style={{
              display: "flex",
              justifyContent: "center",
              paddingBottom: "5rem",
              background: "#F5F8FF",
            }}
          >
            <Box className={classes.right}>
              <Outlet />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
export default LoginPage;
